export default __webpack_public_path__ + "static/media/cookie.736cbcdb.svg";